import React from 'react';
import { components, GroupBase, ClearIndicatorProps, ControlProps } from 'react-select';
import * as Colors from '../../../constants/Colors';
import { CloseIcon } from '../../../icons';

export const ClearIndicator = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(
    props: ClearIndicatorProps<Option, IsMulti, Group>
) => {
    const { height } = props.getStyles('control', props as ControlProps<Option, IsMulti, Group>);
    return (
        <components.ClearIndicator {...props}>
            <CloseIcon
                width={`calc(${height} * .5)`}
                height={`calc(${height} * .5)`}
                color={Colors.purple}
                cursor="pointer"
            />
        </components.ClearIndicator>
    );
};
